<script setup>
import { computed } from 'vue'
import Icon from './Icon.vue'
import TripFinderSearchActionButton from './TripFinderSearchActionButton.vue'

const props = defineProps({
  currentFilterCount: {
    type: Number,
    default: 0,
  },
  isRefineEnabled: {
    type: Boolean,
    default: false,
  },
  isRefineOpen: {
    type: Boolean,
    default: false,
  },
  isSearchEnabled: {
    type: Boolean,
    default: false,
  },
  isSearching: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['search', 'toggleRefine'])

const refineButtonClass = computed(() => ([
  'tripfinder-desktop-refine-button px-5 py-3 flex items-center transition-colors rounded-full shadow-sm',
  props.isRefineEnabled
    ? (props.isRefineOpen
      ? 'bg-white border border-[#2F3033] text-[#4ECF84]'
      : 'bg-white border border-[#2F3033] text-gray-700')
    : 'bg-gray-100 text-gray-400 cursor-not-allowed',
]))

const refineIconClass = computed(() => {
  if (!props.isRefineEnabled) {
    return 'text-gray-400'
  }

  return props.currentFilterCount > 0 ? 'text-[#4ECF84]' : 'text-[#2F3033]'
})
</script>

<template>
  <div class="tripfinder-desktop-action-controls flex items-center gap-[10px]">
    <div class="flex-shrink-0 relative">
      <button
        :class="refineButtonClass"
        :disabled="!isRefineEnabled"
        @click="emit('toggleRefine')"
      >
        <Icon
          name="sliders-vertical"
          class="w-4 h-4 mr-2"
          :class="refineIconClass"
        />
        <span class="text-base font-semibold">Refine Trip</span>
      </button>
    </div>

    <div class="flex-shrink-0">
      <TripFinderSearchActionButton
        :disabled="!isSearchEnabled || isSearching"
        :is-searching="isSearching"
        variant="desktop"
        @search="emit('search')"
      />
    </div>
  </div>
</template>
